var _class, _descriptor, _FeaturesService;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { getItemFromLocalStorage, setItemInLocalStorage } from "core/utils/use-local-storage";
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["DmpConnectIsDevelopmentMode"] = "DmpConnectIsDevelopmentMode";
  return Feature;
}({});
/**
 * A service for handling feature flipping.
 * The status is stored in the local storage.
 */
let FeaturesService = (_class = (_FeaturesService = class FeaturesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
  }
  isEnabled(feature) {
    return this.features[feature];
  }
  enable(feature) {
    const features = FeaturesService.storedFeatures;
    features[feature] = true;
    FeaturesService.storeFeatures(features);
    this.features = features;
  }
  disable(feature) {
    const features = FeaturesService.storedFeatures;
    features[feature] = false;
    FeaturesService.storeFeatures(features);
    this.features = features;
  }
  reset() {
    FeaturesService.storeFeatures(FeaturesService.defaultFeatures);
    this.features = FeaturesService.defaultFeatures;
  }
  static get storedFeatures() {
    const serializedFeatures = getItemFromLocalStorage(FeaturesService.featuresKey);
    if (serializedFeatures) {
      return JSON.parse(serializedFeatures);
    }
    return this.defaultFeatures;
  }
  static storeFeatures(features) {
    setItemInLocalStorage(FeaturesService.featuresKey, JSON.stringify(features));
  }
}, _defineProperty(_FeaturesService, "featuresKey", "features:activations"), _defineProperty(_FeaturesService, "defaultFeatures", {
  DmpConnectIsDevelopmentMode: false
}), _FeaturesService), _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return FeaturesService.storedFeatures;
  }
}), _class);
export { FeaturesService as default };